import { FormControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import * as moment from 'moment';

export class FormValidators {
    static codeValidator(control: FormControl): { [s: string]: boolean } {
        const regex = new RegExp('^[a-z0-9_]+$', 'g');
        if (!regex.test(`${control.value}`)) {
            return { codeIsInvalid: true };
        }
        return null;
    }

    static patientCodeValidator(control: FormControl): { [s: string]: boolean } {
        const regex = new RegExp('^[a-z0-9]+$', 'g');
        if (!regex.test(`${control.value}`)) {
            return { patientCodeIsInvalid: true };
        }
        return null;
    }

    static validFollowUpVisitDate(controlDate: Date): ValidatorFn {
        return (control: FormControl): { [s: string]: boolean } => {
            const isDateValid = moment(control.value).isAfter(moment(controlDate));
            if (isDateValid) return null;

            return { followUpVisitDateIsInvalid: true };
        }
    }
}
